<template>
  <div
    v-if="toShow"
    class="navbar-end"
  >
    <div
      v-if="(!isAdmin && (anyNonOpen || openAttentionCases)) || isAdmin"
      class="navbar-item"
    >
      <router-link
        tag="button"
        class="button home"
        :class="String($route.name).indexOf('home') !== -1 && 'is-active'"
        :to="{ 'name': isAdmin ? 'admin-home' : 'home', query: {}}"
      >
        <span>Home</span>
      </router-link>
    </div>
    <template v-if="$store.state.auth.isAuthenticated">
      <template v-if="isAdmin">
        <div class="navbar-item">
          <router-link
            tag="button"
            class="button my-submissions"
            :class="$route.name === 'admin-find-drafts' && 'is-active'"
            :to="{ 'name': 'admin-find-drafts', query: {}}"
          >
            <span>My submissions</span>
          </router-link>
        </div>
        <div class="navbar-item">
          <router-link
            tag="button"
            class="button admin-users"
            :class="$route.name === 'admin-users' && 'is-active'"
            :to="{ 'name': 'admin-users' }"
          >
            <span>Admins</span>
          </router-link>
        </div>
      </template>
      <div
        v-if="(!isAdmin && (anyNonOpen || openAttentionCases)) || isAdmin"
        class="navbar-item"
      >
        <router-link
          tag="button"
          class="button"
          :class="$route.name === 'cases' && 'is-active'"
          :to="{ 'name': 'cases' }"
        >
          <span
            v-if="openAttentionCases"
            class="badge is-danger"
          >{{ openAttentionCases }}</span>
          <span>Cases</span>
        </router-link>
      </div>
      <div class="navbar-item">
        <div
          :class="{ 'is-active': openProfileDropdown }"
          class="dropdown"
          lang="en"
          @click="$event.stopPropagation()"
        >
          <div class="dropdown-trigger">
            <button
              class="button is-primary namemenu-button"
              aria-haspopup="true"
              aria-controls="dropdown-menu"
              @click="openProfileDropdown = !openProfileDropdown"
            >
              <span class="icon is-large">
                <i
                  class="fas fa-user-circle user-select-menu"
                  aria-hidden="true"
                />
              </span>
              <span>{{ loggedIn.firstName }} {{ loggedIn.lastName }}</span>
              <span class="icon is-small">
                <i
                  class="fas fa-angle-down user-dropdown"
                  aria-hidden="true"
                />
              </span>
            </button>
          </div>
          <div
            id="dropdown-menu"
            class="dropdown-menu"
            role="menu"
          >
            <div class="dropdown-content">
              <router-link
                v-if="!isAdmin && $route.name !== 'profile'"
                role="menuitem"
                class="dropdown-item myprofile-dropdown"
                :to="{ 'name': 'profile' }"
              >
                My Profile
              </router-link>
              <a
                role="menuitem"
                class="dropdown-item logout-dropdown"
                @click.prevent="logout"
              >
                Logout
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- <template v-else>
      <div class="navbar-item">
        <router-link
          tag="button"
          class="button login-btn"
          :class="$route.name === 'login' && 'is-active'"
          :to="{ 'name': 'login' }"
        >
          Login
        </router-link>
      </div>
      <div class="navbar-item">
        <router-link
          tag="button"
          class="button register-btn"
          :class="$route.name === 'register-form' && 'is-active'"
          :to="{ 'name': 'register-form' }"
        >
          Register
        </router-link>
      </div>
    </template> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      toShow: false,
      openProfileDropdown: false,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.account;
    },
  },
  mounted() {
    document.addEventListener('click', () => {
      this.openProfileDropdown = false;
    });
  },
  beforeMount() {
    window.addEventListener("load", this.showMenu);
  },
  methods: {
    showMenu() {
      this.toShow = true;
    },
    logout() {
      this.$store.dispatch('phillyAccount/msalSignOut');
    },
  },
};
</script>
<style lang="scss" scoped>
  @include until($tablet) {
    .navbar-item {
      flex-direction: column;
      .button {
        margin: 0.5rem 0 !important;
      }
    }
  }

  .dropdown {
    // .button.is-primary {
    //   border: 1px solid #fff;
    // }
    .dropdown-menu {
      min-width: 100%;
    }
  }
</style>
